import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import SectionList from "../pages/section/page";
import ArticleDetail from "../pages/article/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "section/:slug", element: <SectionList /> },
      { path: "article/:slug", element: <ArticleDetail /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
      { path: "contact", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;